// Sections TYPE GUARDS

import {
  IWedding_Website_Section,
  IWedding_Website_Section_GiftListField,
  IWedding_Website_Section_HotelsField,
  IWedding_Website_Section_PhotosField,
  IWedding_Website_Section_QuestionAnswerField,
  IWedding_Website_Section_ScheduleField,
  IWedding_Website_Section_TextField,
  IWedding_Website_Section_VenueField,
} from '@bridebook/models/source/models/Weddings.types';
import { SECTION_NAMES } from '../constants';

export const isGiftListSection = (
  section: IWedding_Website_Section,
): section is IWedding_Website_Section_GiftListField => section.type === 'GiftListField';

export const isTextFieldSection = (
  section: IWedding_Website_Section,
): section is IWedding_Website_Section_TextField => section.type === 'TextField';

export const isOurStorySection = (
  section: IWedding_Website_Section,
): section is IWedding_Website_Section_TextField =>
  section.type === 'TextField' && section.name === SECTION_NAMES.OUR_STORY;

export const isVenueSection = (
  section: IWedding_Website_Section,
): section is IWedding_Website_Section_VenueField =>
  section.type === 'VenueField' && section.name === SECTION_NAMES.PRIMARY_VENUE;

export const isPrimaryVenueSection = (
  section: IWedding_Website_Section,
): section is IWedding_Website_Section_VenueField =>
  section.type === 'VenueField' && section.name === SECTION_NAMES.PRIMARY_VENUE;

export const isHotelsSection = (
  section: IWedding_Website_Section,
): section is IWedding_Website_Section_HotelsField => section.type === 'HotelsField';

export const isFaqSection = (
  section: IWedding_Website_Section,
): section is IWedding_Website_Section_QuestionAnswerField =>
  section.type === 'QuestionAnswerField' && section.name === SECTION_NAMES.FAQ;

export const isScheduleSection = (
  section: IWedding_Website_Section,
): section is IWedding_Website_Section_ScheduleField =>
  section.type === 'ScheduleField' && section.name === SECTION_NAMES.SCHEDULE;

export const isPrimaryPhotoSection = (
  section: IWedding_Website_Section,
): section is IWedding_Website_Section_PhotosField =>
  section.type === 'PhotosField' && section.name === SECTION_NAMES.PRIMARY_PHOTOS;
